import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useNavigate } from 'react-router-dom'
import TextTruncate from 'react-text-truncate'
import { useDispatch } from 'react-redux'

import {
    BiEdit,
    LocationOnOutlinedIcon,
    RiDeleteBin6Line,
    EventAvailableOutlinedIcon,
} from '../../../Assets'
import styles from './ProjectListView.module.css'
import ScrollableTabs from '../../ScrollAbleTabs/ScrollAbleTabs'
import { postedDuration } from '../../../Utils/utils'

const ProjectListView = ({
    deleteBtn,
    color,
    path,
    setAlert,
    projectDetails,
    deleteJob,
}) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [paraLine, setParaLine] = useState(true)
    const [hover, setHover] = useState(false)
    const [isTextLong, setIsTextLong] = useState(false)
    const paraHandler = (e) => {
        e.stopPropagation()
        setParaLine(!paraLine)
    }

    const hoverHandler = (event) => {
        if (event === 'enter') {
            setHover(true)
            return
        }
        setHover(false)
    }

    const editJob = (e) => {
        e.stopPropagation()
        console.log('edit')
        navigate(`/buildstudio/editbsproject/${slug}`)
    }

    const {
        title,
        created_at,
        city,
        state,
        address,
        zipcode,
        services_count,
        description,
        services,
        slug,
    } = projectDetails || {}

    const wordLimit = 250

    const truncateText = (text, maxLength) => {
        return text.length > maxLength
            ? text.substring(0, maxLength) + '…'
            : text
    }

    useEffect(() => {
        const wordCount = description.length
        if (wordCount > wordLimit) {
            setIsTextLong(true)
        } else {
            setIsTextLong(false)
        }
    }, [description])

    return (
        <section
            className={styles.jobCardWrapper}
            onMouseEnter={() => hoverHandler('enter')}
            onMouseLeave={() => hoverHandler('leave')}
            onClick={() => {
                navigate(`jobdetail/${slug}`)
            }}
        >
            <Box
                className={styles.cardHeader}
                // onClick={() => navigate(`${path}/${slug}`)}
            >
                <Box>
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                        <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                            {title || 'title'}
                        </Typography>
                    </Box>
                    <Typography
                        sx={{ fontSize: 'small', color: 'var(--textColor)' }}
                    >
                        {postedDuration(created_at)}
                    </Typography>
                </Box>
                <section className={styles.cardmodifyBtn}>
                    <Box
                        sx={{
                            backgroundColor: 'var(--editBtnLight)',
                            padding: '5px 10px',
                            borderRadius: '5px',
                            color: 'var(--milestoneText)',
                        }}
                        className={styles.editBtn}
                        onClick={editJob}
                    >
                        <Box sx={{ display: 'flex', gap: '10px' }}>
                            <Typography fontSize={'12px'}>Edit</Typography>
                            <BiEdit />
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            backgroundColor: 'var(--lightRed)',
                            padding: '5px 10px',
                            borderRadius: '5px',
                            color: 'var(--redColor)',
                        }}
                        className={styles.deleteBtn}
                    >
                        <Box
                            sx={{ display: 'flex', gap: '10px' }}
                            onClick={(e) => deleteJob(e, slug)}
                        >
                            <Typography fontSize={'12px'}>Delete</Typography>
                            <RiDeleteBin6Line />
                        </Box>
                    </Box>
                </section>
            </Box>
            <section
                className={styles.headerList}
                // onClick={() => navigate(`${path}/${slug}`)}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        marginRight: '10px',
                        my: '5px',
                        // ml: index !== 0 && "20px",
                    }}
                    className={styles.jobDetails}
                >
                    <LocationOnOutlinedIcon
                        sx={{
                            marginRight: ' 5px',
                            color: 'var(--green)',
                            ml: '-5px',
                            fontSize: '18px',
                        }}
                    />
                    <small>
                        {address}, {city?.label}, {state?.label}, {zipcode}
                    </small>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        marginRight: '10px',
                        my: '5px',
                        ml: '20px',
                    }}
                    className={styles.jobDetails}
                >
                    <EventAvailableOutlinedIcon
                        sx={{
                            marginRight: ' 5px',
                            color: 'var(--primary-color)',
                            fontSize: '18px',
                        }}
                    />
                    <small>Create Date: {created_at}</small>
                </Box>
                <Box
                    sx={{
                        backgroundColor: 'var(--light-green)',
                        padding: '5px 10px',
                        borderRadius: '5px',
                        color: 'var(--green)',
                        ml: 'auto',
                    }}
                    alignSelf={'flex-end'}
                    className={styles.cardSeriveWrapper}
                >
                    <div>
                        <Typography fontSize={'12px'}>
                            {services_count} Services required
                        </Typography>
                    </div>
                </Box>
            </section>
            <section
                className={styles.cardBody}
                // onClick={() => navigate(`${path}/${slug}`)}
            >
                <TextTruncate
                    line={false}
                    element="span"
                    truncateText="…"
                    text={
                        paraLine
                            ? truncateText(description, wordLimit)
                            : description
                    }
                    style={{
                        color: 'var(--textColor)',
                        fontSize: 'medium',
                    }}
                />
            </section>
            {isTextLong && (
                <small className={styles.paraMoreBtn} onClick={paraHandler}>
                    {paraLine ? 'More' : 'Less'}
                </small>
            )}
            <section className={styles.cardFooter}>
                <div>
                    <Typography
                        sx={{
                            fontWeight: 'bold',
                            textWrap: 'nowrap',
                        }}
                    >
                        Services:
                    </Typography>
                </div>
                <ScrollableTabs
                    bgColor={color}
                    hover={hover}
                    servicesTags={services}
                />
            </section>
            {/* {deleteBtn && (
        <Box
          sx={{ display: "flex", justifyContent: "flex-end", my: 2, gap: 2 }}
        >
        
          <WhiteButtonCmp
            title="Permanent Delete Job"
            style={{ borderColor: " red !important", color: "red" }}
          />
          <ButtonCmp
            style={{ width: "max-content", padding: "10px 15px" }}
            title="Restore Job"
          />
        </Box>
      )} */}
        </section>
    )
}

export default ProjectListView
